import React from 'react'
import { mapPage, mapMetaData } from '../../utils/mapper'
import MethodContent from '../../components/method'
import { withStyles } from '@material-ui/core/styles'
import styles from '../../styles/site'

const Method = props => {
  const { policies } = props
  const metadata = mapMetaData(props.data.method)
  const data = mapPage(props.data.method)
  return (
    <div>
      <MethodContent data={data} metadata={metadata} policies={policies} />
    </div>
  )
}

export default withStyles(styles)(Method)

export const query = graphql`
  query methodTypeQuery($id: String!) {
    method: prismicCtMethod(id: { eq: $id }) {
      ...method
    }
    policies: allPrismicCtDoc {
      edges {
        node {
          uid
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/method/method.js